import BlogPostCard from "@/components/blog/blogPostCard";
import type { BlogPostSummary } from "@/lib/ghost";

export const RelatedPosts = ({ posts }: { posts: BlogPostSummary[] }) => {
  if (!posts.length) return null;

  return (
    <section className="w-full space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">Keep reading</h2>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {posts.map((post) => (
          <BlogPostCard key={post.slug} post={post} />
        ))}
      </div>
    </section>
  );
};
